<!-- src/views/SupportView.vue -->
<template>
  <div class="support page">
    <section class="support-hero glass-card">
      <h1>Boozelog Support</h1>
      <p>
        Need a hand or want to share feedback? We are here to help you use Boozelog in a calm,
        responsible way.
      </p>
      <a class="support-email" href="mailto:general@henium.com">general@henium.com</a>
    </section>

    <section class="support-faq glass-card">
      <h2>FAQ</h2>
      <div class="faq-grid">
        <article>
          <h3>How is my data stored?</h3>
          <p>
            Boozelog uses Apple Health (HealthKit) to store drink logs and estimates. HealthKit
            is the source of truth, and your data stays on device or within Health.
          </p>
        </article>
        <article>
          <h3>What does the personal threshold mean?</h3>
          <p>
            It is a self-selected limit you set for awareness. Boozelog estimates when you may
            return below that threshold based on your logged drinks.
          </p>
        </article>
        <article>
          <h3>How accurate are the estimates?</h3>
          <p>
            Estimated alcohol level can vary by person, context, and timing. Boozelog is for
            pacing and reflection, not for legal or safe-to-drive decisions.
          </p>
        </article>
        <article>
          <h3>Does Boozelog share or sell data?</h3>
          <p>
            No. Boozelog does not sell or share your drink data with third parties.
          </p>
        </article>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SupportView',
});
</script>

<style scoped>
.support {
  display: grid;
  gap: 28px;
}

.support-hero {
  padding: 30px 32px;
}

.support-hero h1 {
  font-family: "Palatino", "Book Antiqua", "Georgia", serif;
  font-size: 2.4rem;
  margin: 0 0 12px;
}

.support-hero p {
  margin: 0 0 16px;
  color: var(--muted-ink);
  line-height: 1.6;
}

.support-email {
  font-size: 1.1rem;
  color: var(--ink);
  text-decoration: none;
  border-bottom: 2px solid var(--teal);
  padding-bottom: 2px;
}

.support-faq {
  padding: 28px 32px;
}

.support-faq h2 {
  margin: 0 0 18px;
  font-size: 1.6rem;
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
}

.faq-grid article {
  background: rgba(255, 255, 255, 0.55);
  border-radius: 18px;
  padding: 18px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.faq-grid h3 {
  margin: 0 0 8px;
  font-size: 1.1rem;
}

.faq-grid p {
  margin: 0;
  color: var(--muted-ink);
  line-height: 1.5;
}
</style>
